"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var use_theme_1 = __importDefault(require("../../../global/use-theme"));
var Svg = styled_components_1.default.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  z-index: 3;\n  margin: ", ";\n  transform: translateY(1px);\n"], ["\n  position: relative;\n  z-index: 3;\n  margin: ", ";\n  transform: translateY(1px);\n"])), function (_a) {
    var side = _a.side;
    return "0 " + (side === 'right' ? '8px' : '0px') + " 0 " + (side === 'left' ? '8px' : '0px');
});
var DashMobile = function (_a) {
    var side = _a.side;
    var colours = use_theme_1.default().colours;
    var width = 12;
    return (react_1.default.createElement(Svg, { side: side, height: 2, width: width, stroke: colours.installationSketch.stroke, strokeWidth: 2, fill: 'none' },
        react_1.default.createElement("g", null,
            react_1.default.createElement("path", { d: "M 0 0 l " + width + " 0" }))));
};
exports.default = DashMobile;
var templateObject_1;
//# sourceMappingURL=dash-mobile.component.js.map